import { useState, useEffect } from "react";
import Game from "./components/Game";
import Header from "./components/Header";
import Modal from "./components/Modal";
import DialectDropdown from "./components/DialectDropdownWithDisplay";
import ReloadButton from "./components/ReloadButton";
import Instructions from "./components/Instructions";

function App() {
  const [wordColors, setWordColors] = useState<Array<any>>([]);
  const [closeModal, setCloseModal] = useState<boolean>(true);
  const [gameResult, setGameResult] = useState<string>("idle");
  const options = [
    "Classical",
    "Egyptian",
    "Gulf",
    "Iraqi",
    "Levantine",
    "Maghrebi",
    "Sudanese",
    "Yemeni",
  ];
  const [selectedDialect, setSelectedDialect] = useState<string>(options[0]);

  return (
    <div className="w-1/2 xl:w-2/3 md:w-full relative mx-auto flex flex-col items-center justify-center pb-10 min-h-full">
      <Header closeModal={closeModal} setCloseModal={setCloseModal} />
      <div className="flex items-center gap-x-4 mb-4">
        <Instructions />
        <ReloadButton />
      </div>
      <DialectDropdown
        selectedDialect={selectedDialect}
        setSelectedDialect={setSelectedDialect}
        options={options}
      />
      <Game
        wordColors={wordColors}
        setWordColors={setWordColors}
        setCloseModal={setCloseModal}
        setGameResult={setGameResult}
        gameResult={gameResult}
        dialect={selectedDialect}
      />
      <Modal
        gameResult={gameResult}
        data={wordColors}
        closeModal={closeModal}
        setCloseModal={setCloseModal}
      />
    </div>
  );
}

export default App;
